import React from "react";
import "./Body.css";

import { Container, Row, Col } from "reactstrap";
import Contactform from "../../Components/Contactform/Contactform";

export default class Body extends React.Component {

  render() {
    return (
      <Container className="content-wrapper p-b-0">
        <Row className="top-banner mb-65">
          <Col md="6" className="left">
            <div>
              <p className="small-text">LET’S BUILD INTEGRATIONS THE RIGHT WAY</p>
              <h1>
                Who are we and what are we about?
              </h1>
              <p className="small-text about-text">Certified Integrator is a quality standard for the integration industry. Its main purpose is to assure sustainability and future proof system integrations. The standard was introduced to the market in 2018 and has since become a recognized standard that more and more companies are applying to their IT-strategies. <br />We have a team of trainers who will give you the training you need. All training sessions are presented <a href="https://certifiedintegrator.com/events">here</a>.</p>
            </div>
          </Col>
          <Col md="6" className="right">
            <img
              className="img-fluid aboutus-men d-block mx-auto"
              src={require("../../img/aboutus-men.png")}
              alt="Integrator"
            />
          </Col>
        </Row>
        <div className="contact-wrapper">F
          <Row className="same-height">
            <Col md="6" className="contact-content">
              <h1 className="text-center">We are here <br />to help you!</h1>
              <Row>
                <Col md="6">
                  <img
                    className="img-fluid mx-auto d-block"
                    src={require("../../img/contact-avatar.png")}
                    alt="Integrator"
                  />
                  <h4>Kalle Rosén</h4>
                  <p className="text-center grey">
                    <span className="yellow">Partner & Academy Manager&nbsp;</span>
                    at Certified Integrator
                  </p>
                  <p className="text-center">
                    <span className="grey">Mail:&nbsp;</span>
                    <a className="contact" href="mailto:kalle.rosen@entiros.se?subject=Mail from certifiedintegrator.com">
                      kalle.rosen@entiros.se
                    </a>
                  </p>
                  <p className="text-center">
                    <span className="grey">Tel:&nbsp;</span>
                    <a className="contact" href="tel:+46702246075">
                      +4670 224 60 75
                    </a>
                  </p>
                </Col>
                <Col md="6">
                  <img
                    className="img-fluid mx-auto d-block"
                    src={require("../../img/contact-avatar.png")}
                    alt="Integrator"
                  />
                  <h4>Jonas TS</h4>
                  <p className="text-center grey">
                    <span className="yellow">Sales&nbsp;</span>
                    at Certified Integrator
                  </p>
                  <p className="text-center">
                    <span className="grey">Mail:</span><br />
                    <a className="contact" href="mailto:jonas.ts@entiros.se?subject=Mail from certifiedintegrator.com">
                      jonas.ts@entiros.se
                    </a>
                  </p>
                  <p className="text-center">
                    <span className="grey">Tel:&nbsp;</span>
                    <a className="contact" href="tel:+46703260749">
                      +4670 326 07 49
                    </a>
                  </p>
                </Col>
              </Row>
            </Col>

            <Col md="6"><Contactform /></Col>
          </Row>
        </div>
      </Container>
    );
  }
}